module.exports = __webpack_public_path__ + "static/media/profile-photo.9753dd3a.png";